module.exports = __webpack_public_path__ + "kw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/kw.svg
// module id = 647
// module chunks = 0